module.exports = __webpack_public_path__ + "fonts/tinymce-small.7e0c88f0.woff";